import React from 'react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import s from './empty-state.scss'

export const EmptyState: React.FC = () => {
  const {t} = useTranslation()
  return <div className={s.root}>{t('chat.empty')}</div>
}
